export default "__VITE_ASSET__UtwBR2Og__"